import * as React from 'react'

import { StyledLabel } from './StyledCheckbox.style'

export interface StyledCheckboxProps {
  onClick?: () => void
  checked?: boolean
}

const StyledCheckbox: React.FC<StyledCheckboxProps> = ({ onClick, checked }) => {
  return (
    <StyledLabel className="switch">
      <input type="checkbox" checked={checked} onClick={onClick} />
      <span className="slider round" />
    </StyledLabel>
  )
}

export default StyledCheckbox



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/StyledCheckbox/StyledCheckbox.tsx